import type { Evaluation } from "~/modules/evalutation/types";
import { atom } from "~/observers/jotai";

export const evaluationAtom = atom<Evaluation | undefined>(undefined);
export const evaluationReadOnlyAtom = atom<Evaluation | undefined>(undefined);
